import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { LanguageEntity } from "../../entities/language";

@Injectable()
export class LanguagesRepo extends Repository<LanguageEntity>{
    constructor(private dataSource: DataSource) {
        super(LanguageEntity, dataSource.createEntityManager());
    }

    async getAllLanguages() {
        const data = await this.createQueryBuilder('language')
            .select('language.id ,language.language')
            .getRawMany();
        return data;
    }
}